(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3909],{

/***/ 61551:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hiring",
      function () {
        return __webpack_require__(7900);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/Layout/Header/PostJobButton.tsx
var PostJobButton = __webpack_require__(71968);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/Pages/Hiring/Hero.tsx



const Hero = (param)=>{
    let {} = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "px-6 text-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                className: "text-4xl tracking-tight font-black text-black sm:text-5xl md:text-6xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "block text-yellow-400 xl:inline",
                        children: "Hire JavaScript Developers"
                    }),
                    " "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-3 max-w-md mx-auto text-base text-black sm:text-lg md:mt-5 md:text-xl md:max-w-xl",
                children: "Reach a community of highly skilled JavaScript & TypeScript developers from all over the world."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "my-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostJobButton/* PostJobButton */.b, {
                    cN: "rounded text-white bg-black hover:text-yellow-300"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/Layout/Layout.tsx + 22 modules
var Layout = __webpack_require__(4828);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 18 modules
var format = __webpack_require__(34850);
;// CONCATENATED MODULE: ./pages/hiring/index.tsx




function Home(param) {
    let { jobPost  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* Layout */.A, {
        pageTitle: "Hire top Javascript Developers in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy")),
        metaDescription: "Hire best JavaScript developers from all over the World.",
        bodyCN: "px-4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "max-w-4xl m-auto",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pt-10 pb-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {})
            })
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,8184,4828,9774,2888,179], function() { return __webpack_exec__(61551); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);